import React from 'react';
import { Col, Row } from 'react-bootstrap';

const numero = valor => Number(valor || 0);

const formatarMoeda = valor =>
  numero(valor).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  });

const formatarNumero = (valor, casas) =>
  numero(valor).toLocaleString('pt-BR', {
    minimumFractionDigits: casas,
    maximumFractionDigits: casas,
  });

const ItemResultado = ({ label, valor, destaque }) => (
  <div className={destaque ? 'border rounded p-2 mb-2 bg-light' : 'border rounded p-2 mb-2'}>
    <div className="small text-muted">{label}</div>
    <strong>{valor}</strong>
  </div>
);

const PainelResultados = ({ resultado }) => {
  const dados = resultado || {};
  const prazoMedio = numero(dados.prazo_medio);
  const taxaFinalMes =
    numero(dados.taxa_final_mes) === 0 && prazoMedio === 0
      ? '—'
      : formatarNumero(dados.taxa_final_mes, 4);

  return (
    <div className="bg-white border rounded p-3 h-100">
      <h5 className="mb-3">Resultados</h5>
      <Row>
        <Col xs={12} sm={6} lg={12}>
          <ItemResultado label="Face" valor={formatarMoeda(dados.v_face)} destaque />
        </Col>
        <Col xs={12} sm={6} lg={12}>
          <ItemResultado label="Compra" valor={formatarMoeda(dados.v_compra)} />
        </Col>
        <Col xs={12} sm={6} lg={12}>
          <ItemResultado label="Líquido" valor={formatarMoeda(dados.v_liquido)} destaque />
        </Col>
        <Col xs={6} lg={6}>
          <ItemResultado label="N Documentos" valor={formatarNumero(dados.n_documentos, 0)} />
        </Col>
        <Col xs={6} lg={6}>
          <ItemResultado label="Prazo Médio" valor={formatarNumero(dados.prazo_medio, 2)} />
        </Col>
        <Col xs={12}>
          <ItemResultado label="DespServ" valor={formatarMoeda(dados.desp_serv)} />
        </Col>
        <Col xs={6}>
          <ItemResultado label="AdValorem" valor={formatarMoeda(dados.ad_valorem)} />
        </Col>
        <Col xs={6}>
          <ItemResultado label="ISS" valor={formatarMoeda(dados.iss)} />
        </Col>
      </Row>

      <h6 className="mt-3 mb-2">Taxas</h6>
      <Row>
        <Col xs={6}>
          <ItemResultado label="Desconto Mês" valor={formatarNumero(dados.taxa_desc_mes, 4)} />
        </Col>
        <Col xs={6}>
          <ItemResultado label="Efetiva Mês" valor={formatarNumero(dados.taxa_efetiva_mes, 4)} />
        </Col>
        <Col xs={6}>
          <ItemResultado label="Final Mês" valor={taxaFinalMes} />
        </Col>
        <Col xs={6}>
          <ItemResultado label="Desconto" valor={formatarNumero(dados.taxa_desc, 4)} />
        </Col>
        <Col xs={6}>
          <ItemResultado label="Efetiva" valor={formatarNumero(dados.taxa_efetiva, 4)} />
        </Col>
        <Col xs={6}>
          <ItemResultado label="Final" valor={formatarNumero(dados.taxa_final, 4)} />
        </Col>
      </Row>
    </div>
  );
};

export default PainelResultados;
